import React, { useCallback, useEffect } from "react";

import SearchResults from "../../components/Header/SearchResults";
import setSearchKeywordAction from "../../../state/actions/SearchActions/setSearchKeywordAction";
import { useDispatch } from "react-redux";

const Search: React.FC = () => {
    const dispatch = useDispatch();
    const setSearchKeyword = useCallback(() => dispatch(setSearchKeywordAction("")), [dispatch]);
    useEffect(() => {
        return () => {
            setSearchKeyword();
        };
    });
    return <SearchResults />;
};

export default Search;
